(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2099],{

/***/ 66156:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/desktop",
      function () {
        return __webpack_require__(78630);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);

__webpack_require__(14473);

var Download = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3798), __webpack_require__.e(2678), __webpack_require__.e(4885), __webpack_require__.e(7148), __webpack_require__.e(9521), __webpack_require__.e(9586), __webpack_require__.e(9459), __webpack_require__.e(6819), __webpack_require__.e(2987), __webpack_require__.e(5872), __webpack_require__.e(129), __webpack_require__.e(1107), __webpack_require__.e(1605), __webpack_require__.e(1577), __webpack_require__.e(1977), __webpack_require__.e(4229), __webpack_require__.e(8425), __webpack_require__.e(2647), __webpack_require__.e(2486), __webpack_require__.e(4629), __webpack_require__.e(2186)]).then(__webpack_require__.bind(__webpack_require__, 62186));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62186)
            ];
        }
    }
});
var DownloadDesktopPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Download, {});
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (DownloadDesktopPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(66156); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);